import React from 'react';
import { Link } from 'react-router-dom';
import { FaApple, FaGooglePlay, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaHeart } from 'react-icons/fa';

const Footer = () => {
  const footerLinks = {
    Product: [
      { name: 'Home', path: '/' },
      { name: 'Shop', path: '/shop' },
      { name: 'Download App', path: '/' },
    ],
    Company: [
      { name: 'About Us', path: '/about' },
      { name: 'Blog', path: '/blog' },
      { name: 'Contact', path: '/contact' },
    ],
    Support: [
      { name: 'Help Center', path: '/contact' },
      { name: 'Privacy Policy', path: '/' },
      { name: 'Terms of Service', path: '/' },
    ],
    Community: [
      { name: 'Success Stories', path: '/blog' },
      { name: 'Fitness Tips', path: '/blog' },
      { name: 'Join Community', path: '/about' },
    ],
  };

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-4 hover:opacity-80 transition-opacity">
              <img 
                src="/assets/logo-white.png" 
                alt="MyFitness Logo" 
                className="h-10 w-10"
              />
              <img 
                src="/assets/logo-name-white.png" 
                alt="MyFitness" 
                className="h-6"
              />
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Transform your body and elevate your lifestyle with the world's most
              comprehensive fitness platform.
            </p>
            
            {/* App Download Buttons */}
            <div className="space-y-3">
              <button className="w-full bg-white text-black px-4 py-3 rounded-lg flex items-center justify-center space-x-2 hover:bg-gray-200 transition-colors">
                <FaApple size={24} />
                <div className="text-left">
                  <div className="text-xs">Download on the</div>
                  <div className="font-bold text-sm">App Store</div>
                </div>
              </button>
              <button className="w-full bg-white text-black px-4 py-3 rounded-lg flex items-center justify-center space-x-2 hover:bg-gray-200 transition-colors">
                <FaGooglePlay size={24} />
                <div className="text-left">
                  <div className="text-xs">Get it on</div>
                  <div className="font-bold text-sm">Google Play</div>
                </div>
              </button>
            </div>
          </div>

          {/* Links Columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-white font-bold mb-4">{category}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-gray-400 hover:text-primary transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-gray-400 text-sm flex items-center">
              <span>© 2026 MyFitness. Made with</span>
              <FaHeart className="text-primary mx-1" />
              <span>for fitness enthusiasts worldwide.</span>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4">
              {[
                { icon: <FaFacebook />, link: '#' },
                { icon: <FaTwitter />, link: '#' },
                { icon: <FaInstagram />, link: '#' },
                { icon: <FaLinkedin />, link: '#' },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  className="w-10 h-10 bg-gray-800 hover:bg-primary rounded-lg flex items-center justify-center text-white transition-colors"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
